import { DebidaDiligencia } from './debida-diligencia.model';
import { Direccion } from './direccion.model';
import { DocumentoDeIdentidad } from './documento-de-identidad.model';
import { Profesion } from './profesion.model';
import { SectorActividad } from './sector-actividad.model';
import { Pais } from './pais.model';
import { Usuario } from './usuario.model';
import { RazonSocial } from './razon-social.model';
import { TipoSujetoObligado } from './tipo-sujeto-obligado.model';
import { PersonaFisica } from './persona-fisica.model';
import { Contacto } from './contacto.model';


export class PersonaJuridica
{
    id: number;
    tipo: string;
    active: number;
    creador: Usuario;
    createdAt: Date;
    nombre: string;
    nombreFiscal: string;
    razonSocial: RazonSocial;
    descripcion: string;
    direccion: Direccion;
    direccionFiscal: Direccion;
    //sectorIndustrial: SectorActividad;
    contacto: Contacto;
    externalId: string;
    tipoSujetoObligado: TipoSujetoObligado;
    accionistas: PersonaFisica[];
    direccionFisica: Direccion;
    
    /**
     * Constructor
     *
     * @param personaFisica
     */
    constructor(personaFisica)
    {
        {
            this.id = personaFisica.id || null;
            this.tipo = personaFisica.tipo || null;
            this.active = personaFisica.active || 0;
            this.nombre = personaFisica.nombre || '';
            this.creador = personaFisica.creador;
            this.createdAt = personaFisica.createdAt;
            this.nombreFiscal = personaFisica.nombreFiscal;
            this.razonSocial = personaFisica.razonSocial || new RazonSocial({});
            this.descripcion = personaFisica.descripcion;
            this.direccion = personaFisica.direccion || new Direccion({});
            this.direccionFiscal = personaFisica.direccionFiscal || new Direccion({});
            //this.sectorIndustrial = personaFisica.sectorIdustrial;
            this.contacto = personaFisica.contacto || new Contacto({});
            this.externalId = personaFisica.externalId;
            this.tipoSujetoObligado = personaFisica.tipoSujetoObligado;
            this.accionistas = personaFisica.accionistas || [];
        }
    }
}
